import { formatNumeric } from '@common/utils'

const Noticia = ({ dadesCMS }) => {
	return (
		<div id='taula_grossa'>
			<div className='taula'>
				<div className='titol'>
					<div className='l1'>PRIMER PREMI</div>
					<div className='l2'>Premi per bitllet</div>
				</div>
				<div>
					<div className='l5'>
						{formatNumeric(dadesCMS?.primer_premi)} + Sèrie {dadesCMS?.serie}
					</div>
					<div className='l3'>2.000.000€</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(dadesCMS?.primer_premi)}</div>
					<div className='l3'>50.000€</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(Number(dadesCMS?.primer_premi) - 1)} (anterior)</div>
					<div className='l3'>2.000€</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(Number(dadesCMS?.primer_premi) + 1)} (posterior)</div>
					<div className='l3'>2.000€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.primer_premi.substring(1)}`}</div>
					<div className='l3'>500€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.primer_premi.substring(2)}`}</div>
					<div className='l3'>100€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.primer_premi.substring(3)}`}</div>
					<div className='l3'>30€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.primer_premi.substring(4)}`}</div>
					<div className='l3'>5€</div>
				</div>
			</div>
			<div className='taula'>
				<div className='titol'>
					<div className='l1'>SEGON PREMI</div>
					<div className='l2'>Premi per bitllet</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(dadesCMS?.segon_premi)}</div>
					<div className='l3'>20.000€</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(Number(dadesCMS?.segon_premi) - 1)} (anterior)</div>
					<div className='l3'>500€</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(Number(dadesCMS?.segon_premi) + 1)} (posterior)</div>
					<div className='l3'>500€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.segon_premi.substring(1)}`}</div>
					<div className='l3'>200€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.segon_premi.substring(2)}`}</div>
					<div className='l3'>30€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.segon_premi.substring(3)}`}</div>
					<div className='l3'>10€</div>
				</div>
			</div>
			<div className='taula'>
				<div className='titol'>
					<div className='l1'>TERCER PREMI</div>
					<div className='l2'>Premi per bitllet</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(dadesCMS?.tercer_premi)}</div>
					<div className='l3'>10.000€</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(Number(dadesCMS?.tercer_premi) - 1)} (anterior)</div>
					<div className='l3'>200€</div>
				</div>
				<div>
					<div className='l5'>{formatNumeric(Number(dadesCMS?.tercer_premi) + 1)} (posterior)</div>
					<div className='l3'>200€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.tercer_premi.substring(1)}`}</div>
					<div className='l3'>100€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.tercer_premi.substring(2)}`}</div>
					<div className='l3'>20€</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.tercer_premi.substring(3)}`}</div>
					<div className='l3'>5€</div>
				</div>
			</div>
			<div className='taula'>
				<div className='titol'>
					<div className='l1'>SEGON REINTEGRAMENT</div>
					<div className='l2'>Premi per bitllet</div>
				</div>
				<div>
					<div className='l5'>Acabats en {`${dadesCMS?.segon_reintegrament}`}</div>
					<div className='l3'>5€</div>
				</div>
			</div>
		</div>
	)
}

export default Noticia
